import { NgOptimizedImage } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, provideAppInitializer, inject, importProvidersFrom } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
// eslint-disable-next-line @typescript-eslint/naming-convention
import Material from '@primeuix/themes/material';
import { BASE_PATH, ApiModule } from 'oneorm-api-http-client';
import { BASE_PATH as CCMT_BASE_PATH, ApiModule as CcmtApiModule } from 'oneorm-ccmt-api-http-client';
import { BASE_PATH as QUERY_BASE_PATH, ApiModule as QueryApiModule } from 'oneorm-query-api-http-client';
import { providePrimeNG } from 'primeng/config';

import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { provideAuth } from './app/core/authorization/auth.provider';
import { provideCore } from './app/core/core.config';
import { FavIconService } from './app/shared/services/favicon.service';
import { GraphService } from './app/shared/services/graph.service';
import { SubscriptionVariablesService } from './app/shared/services/subscription-variables.service';
import { ThemeDetectionService } from './app/shared/services/theme-detection.service';
import { ToastService } from './app/shared/services/toast.service';
import { registerDeveloperMode } from './app/shared/utils/developer-mode.util';
import { environment } from './environments/environment';

function initializeThemeDetection(themeDetectionService: ThemeDetectionService) {
  return () => themeDetectionService.init();
}

if (environment.production) {
  enableProdMode();
}

registerDeveloperMode(environment.enableDeveloperModeBypass);

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, ApiModule, CcmtApiModule, QueryApiModule, MatSidenavModule, MsalModule, NgOptimizedImage),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'disabled',
      })
    ),
    provideCore(),
    GraphService,
    SubscriptionVariablesService,
    ToastService,
    { provide: BASE_PATH, useValue: environment.apiUrl },
    { provide: CCMT_BASE_PATH, useValue: environment.ccmtApiUrl },
    { provide: QUERY_BASE_PATH, useValue: environment.queryApiUrl },
    provideAuth(),
    provideHttpClient(withInterceptorsFromDi()),
    FavIconService,
    ThemeDetectionService,
    provideAppInitializer(() => {
      const initializerFn = initializeThemeDetection(inject(ThemeDetectionService));
      return initializerFn();
    }),
    providePrimeNG({
      theme: {
        preset: Material,
        options: {
          darkModeSelector: '.dark-mode-selected',
        },
      },
    }),
  ],
}).catch(err => console.error(err));
